// Generated by scripts/theme-config/theme-config.js from api::theme-configuration. Do not edit.

/**
 * Pagination preset elegido por el tenant. `legacy` reproduce el
 * look histórico (cells 40×40, rounded-custom, gaps 12px). `compact`
 * sigue el Figma de HoM (cells 24×24 pill, gaps 8/20px, texto blanco
 * en activo).
 */
export type GeneratedPaginationStyle = 'legacy' | 'compact';

export const generatedPaginationStyle: GeneratedPaginationStyle = 'legacy';
